"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Bubble_1 = __importDefault(require("../Bubble"));
var styled_components_1 = __importStar(require("styled-components"));
var constant_1 = require("../../constant");
var arrowMove = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    bottom: 15px;\n  }\n  50% {\n    bottom: 10px;\n  }\n  100% {\n    bottom: 15px;\n  }\n"], ["\n  0% {\n    bottom: 15px;\n  }\n  50% {\n    bottom: 10px;\n  }\n  100% {\n    bottom: 15px;\n  }\n"])));
var ArrowBottom = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: 10px solid transparent;\n  border-top-color: #000;\n  height: 0;\n  width: 0;\n  margin-top: 10px;\n\n  ", " {\n    margin-top: 26px;\n  }\n"], ["\n  border: 10px solid transparent;\n  border-top-color: #000;\n  height: 0;\n  width: 0;\n  margin-top: 10px;\n\n  ", " {\n    margin-top: 26px;\n  }\n"])), constant_1.MEDIA.MAX.xxs);
var ButtonArrow = styled_components_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  bottom: 15px;\n  left: calc(50% - 20px);\n  height: 40px;\n  width: 40px;\n  animation: 0.5s ", " ease infinite;\n  background: none;\n  border: none;\n"], ["\n  cursor: pointer;\n  position: absolute;\n  bottom: 15px;\n  left: calc(50% - 20px);\n  height: 40px;\n  width: 40px;\n  animation: 0.5s ", " ease infinite;\n  background: none;\n  border: none;\n"])), arrowMove);
var ScrollingTextBubble = function (_a) {
    var scrollingTexts = _a.scrollingTexts, position = _a.position;
    var _b = react_1.useState(1), nbLettersDisplayed = _b[0], setNbLettersDisplayed = _b[1];
    var _c = react_1.useState(0), currentText = _c[0], setCurrentText = _c[1];
    var handleChangeText = function () {
        if (currentText < scrollingTexts.length - 1) {
            setCurrentText(currentText + 1);
            setNbLettersDisplayed(1);
        }
    };
    react_1.useEffect(function () {
        var timeout = setTimeout(function () {
            if (scrollingTexts[currentText].length > nbLettersDisplayed) {
                setNbLettersDisplayed(nbLettersDisplayed + 1);
            }
        }, 30);
        return function () {
            clearTimeout(timeout);
        };
    }, [nbLettersDisplayed]);
    var showArrow = scrollingTexts[currentText].length <= nbLettersDisplayed &&
        currentText < scrollingTexts.length - 1;
    return (react_1.default.createElement(Bubble_1.default, { position: position },
        scrollingTexts[currentText].substring(0, nbLettersDisplayed),
        showArrow && (react_1.default.createElement(ButtonArrow, { onClick: handleChangeText },
            react_1.default.createElement(ArrowBottom, null)))));
};
exports.default = ScrollingTextBubble;
var templateObject_1, templateObject_2, templateObject_3;
